import React from 'react'
import AudioLevelIndicator from '../../AudioLevelIndicator'
import { FormControl, MenuItem, Typography, Select, Grid } from '@mui/material'

import { useDevices, useLocalSessionId, useVideoTrack, useAudioTrack,  } from '@daily-co/daily-react'

export default function AudioInputList() {
  const { currentMic, microphones, setMicrophone } = useDevices()
  const localSessionId = useLocalSessionId()
  const localAudio = useAudioTrack(localSessionId)

  const updateSpeakers = (e:any) => {
    setMicrophone(e.target.value)
  }

  return (
    <div>
      <Typography 
        variant="subtitle2" 
        gutterBottom>
        Audio Input
      </Typography>
      <Grid 
        container 
        alignItems="center" 
        justifyContent="space-between">
        <div 
          className="inputSelect">
          {microphones.length > 1 ? (
            <FormControl 
              fullWidth>
              <Select
                onChange={updateSpeakers}
                value={currentMic?.device?.deviceId || ''}
                variant="outlined"
              >
                {microphones.map(device => (
                  <MenuItem 
                    value={device.device.deviceId} 
                    key={device.device.deviceId} >
                    {device.device.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          ) : (
            <Typography>{localAudio?.track?.id || 'No Local Audio'}</Typography>
          )}
        </div>
        <AudioLevelIndicator audioTrack={localAudio?.track} color="black" />
      </Grid>
    </div>
  );
}
